export const FORM_USER_MANAGEMENT = 'userManagement'
export const FORM_CLIENT_AUTHORIZATION = 'clientAuthorization'
export const FORM_ClIENT_EDIT = 'clientEdit'
export const FORM_ClIENT_ROLES_EDIT = 'clientRolesEdit'
export const FORM_ENDPOINT_EDIT = 'endpointEdit'
export const FORM_TINY_URL_MANAGEMENT = 'tinyUrlManagement'
export const FORM_INVITATION_EDIT = 'invitationEdit'
export const FORM_ORGANIZATION_EDIT = 'organizationEdit'
export const FORM_CONNECTION_EDIT = 'connectionEdit'

// Schedule (events/venues)
export const FORM_VENUE_TEMPLATE = 'venueTemplate'
export const FORM_EVENT_TEMPLATE = 'eventTemplate'
export const FORM_EVENT = 'event'
export const FORM_VENUE_SCHEDULE = 'venueSchedule'
export const FORM_VENUE_BULK_UPDATE = 'venueBulkUpdate'
export const FORM_EVENT_BULK_UPDATE = 'eventBulkUpdate'
export const FORM_VENUE = 'venue'
